<template lang="pug">
  div.display-contents
    img(
      v-if="img"
      :src="getYoutubeEmbedLink(this.img, true)"
      width="100%"
    )
    iframe(
      v-if="link"
      :height="height"
      :src="getYoutubeEmbedLink(this.link)"
      width="100%"
      frameborder="0"
      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    )
</template>

<script>
import getYoutubeEmbedLink from '@/utils/youtube-utils';

export default {
  name: 'YoutubeEmbed',
  props: {
    img: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '200',
    },
  },
  methods: {
    getYoutubeEmbedLink,
  },
};
</script>
